"use client";
import Cleave from "cleave.js/react";
import { ReactInstanceWithCleave } from "cleave.js/react/props";
import { forwardRef, useEffect, useRef, useState } from "react";
import TextField from "../TextField";
import { TextFieldProps } from "../TextField/types";

export type NumberFieldProps = {
  format?: boolean;
  germanLocale?: boolean;
  autoDefaultValue?: number;
} & TextFieldProps;

const NumberField = forwardRef<NumberFieldProps, any>(function NumberField(
  {
    onChange,
    value,
    format = true,
    germanLocale = true,
    autoDefaultValue,
    onBlur,
    ...props
  },
  ref,
) {
  const numeralDecimalMark = germanLocale ? "," : ".";
  const delimiter = germanLocale ? "." : ",";
  const isDecimalMark = useRef(false);
  const [cleave, setCleave] = useState<ReactInstanceWithCleave>();

  const handleChange = (event: any) => {
    const number = event.target.rawValue ? Number(event.target.rawValue) : null;
    isDecimalMark.current = event.target.value.endsWith(numeralDecimalMark);
    onChange?.(number);
  };

  const handleBlur = (
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    // If autoDefaultValue is provided and the field is empty, set it to the default value
    if (
      autoDefaultValue !== undefined &&
      (value === null || value === undefined || value === "")
    ) {
      onChange?.(autoDefaultValue);
    }

    // Call the original onBlur if provided
    onBlur?.(event);
  };

  useEffect(() => {
    let rawValue = isNaN(value) ? "" : String(value);
    if (isDecimalMark.current) {
      rawValue += numeralDecimalMark;
    }
    cleave?.setRawValue(rawValue);
  }, [value, isDecimalMark, cleave, numeralDecimalMark]);

  return (
    <TextField
      {...props}
      htmlRef={ref}
      // @ts-expect-error TODO: replace cleave.js (deprecated) by new library cleave-zen
      as={Cleave}
      value="0"
      onInit={setCleave}
      options={{
        numeralDecimalMark: numeralDecimalMark,
        delimiter: format ? delimiter : "",
        numeral: true,
      }}
      onChange={handleChange}
      onBlur={handleBlur}
      inputMode="numeric"
    />
  );
});

export default NumberField;
